import module from './module.js'

import './components/component.js'
import './components/agregar/component.js'
import './components/completados/component.js'
import './components/completados/grupo/component.js'
import './components/completados/item/component.js'
import './components/completados/lista/component.js'
import './components/eliminar/component.js'
import './components/launcher/component.js'
import './components/pendientes/component.js'
import './components/pendientes/grupo/component.js'
import './components/pendientes/item/component.js'
import './components/pendientes/lista/component.js'
import './routes/finiquitos.js'
import './routes/finiquitos/completados.js'
import './routes/finiquitos/sumario.js'
import './services/Finiquitos.js'
import './services/finiquitos/Completados.js'
import './services/finiquitos/Finiquito.js'
import './services/finiquitos/Proyectos.js'
import './services/finiquitos/Proyecto/Colaboradores.js'

export default module.name



// WEBPACK FOOTER //
// ./src/nominas/finiquitos/index.js